import React, { useState, useEffect } from 'react';
import { Dialog, Box, Skeleton, Radio, RadioGroup, FormControlLabel, FormControl } from '@mui/material';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from 'react-intl';
import Api from '../../services/api';
import { getCalledGridById } from '../../services/called.service';
import CalledFinish from '../../calledFinish/src/js/CalledFinish';
import TransitionsModal from '../../components/modal/modal';
import { getSlaAtendimento, getSlaSolucao } from '../called-list/called.functions';
import * as calledsActions from '../../redux/actions/calleds';

function KanbanFinishModal({
  open,
  calledId,
  targetStatusId,
  targetStatus,
  onClose,
  onFinishSuccess,
  onOptimisticClose,
  onMoveError,
  userSession,
  intl,
  addAccompanimentsList,
  history,
  match,
}) {
  const [loading, setLoading]                       = useState(false);
  const [submitting, setSubmitting]                 = useState(false);
  const [calledGridData, setCalledGridData]         = useState(null);
  const [actionDescription, setActionDescription]  = useState('');
  const [finishAccompanimentId, setFinishAccompanimentId] = useState(null);
  const [files, setFiles]                           = useState([]);
  const [defaultActionList, setDefaultActionList]   = useState([]);
  const [closingFormData, setClosingFormData]       = useState(null);
  const [closingFormData2, setClosingFormData2]     = useState(null);
  const [toast, setToast]                           = useState({ open: false, message: '', severity: 'error' });
  const [privacy, setPrivacy]                       = useState(false);
  const timerRef = React.useRef(null);

  React.useEffect(() => {
    return () => { if (timerRef.current) clearTimeout(timerRef.current); };
  }, []);

  useEffect(() => {
    if (!open || !calledId) return;

    setLoading(true);
    setCalledGridData(null);
    setFiles([]);
    setActionDescription('');
    setFinishAccompanimentId(null);
    setClosingFormData(null);
    setClosingFormData2(null);
    setPrivacy(false);
    setDefaultActionList([]);

    getCalledGridById(calledId)
      .then((res) => {
        if (res?.success && res?.data?.id) {
          const data = res.data;
          setCalledGridData(data);

          if (data.organizationid) {
            Api.get(`/defaultaction/byorganizationid/${data.organizationid}`)
              .then((r) => {
                if (r?.data?.data) {
                  const formatted = r.data.data
                    .map((item) => ({
                      ...item,
                      name: item.title && item.title !== '' ? item.title : item.text,
                    }))
                    .sort((a, b) => a.name.localeCompare(b.name));
                  setDefaultActionList(formatted);
                }
              })
              .catch(() => {});
          }
        } else {
          setToast({ open: true, message: intl.formatMessage({ id: 'process.error' }), severity: 'error' });
          onClose();
        }
      })
      .finally(() => setLoading(false));
  }, [open, calledId]);

  const closeModalFinish = () => onClose();
  const closeModalCalledFinish = () => onClose();
  const addFileItem = (file) => setFiles((prev) => [...prev, file]);
  const removeItem = (index) => setFiles((prev) => prev.filter((_, i) => i !== index));
  const setDefaultActionAccompaniment = (action) => {
    if (action) setActionDescription(action.description ?? '');
  };
  const actionRadio = () => (
    <FormControl>
      <RadioGroup
        row
        value={privacy ? 'private' : 'public'}
        onChange={(e) => setPrivacy(e.target.value === 'private')}
      >
        <FormControlLabel value="public"  control={<Radio size="small" />} label="Ação pública" />
        <FormControlLabel value="private" control={<Radio size="small" />} label="Ação privada" />
      </RadioGroup>
    </FormControl>
  );

  const calledFinishOk = async () => {
    if (!calledGridData) return;
    setSubmitting(true);

    const newData = new FormData();

    // Called fields — PascalCase as required by CalledUpdateViewModel
    newData.append('Id', calledGridData.id);
    newData.append('Title', calledGridData.title ?? '');
    newData.append('Description', calledGridData.description ?? ' ');
    newData.append('Status', targetStatusId);
    newData.append('Type', calledGridData.typeid ?? 0);
    newData.append('Organization', calledGridData.organizationid ?? 0);
    newData.append('OrganizationCategory', calledGridData.organizationcategoryid ?? 0);
    newData.append('RequestingUser', calledGridData.requestinguserid ?? 0);
    newData.append('OriginRequest', calledGridData.originrequestid ?? 0);
    newData.append('AddressId', calledGridData.addressid ?? 0);
    newData.append('AssignedUser', calledGridData.assigneduserid ?? 0);
    newData.append('TechinicalTeamId', calledGridData.techinicalteamid ?? 0);
    newData.append('ObservantUser', calledGridData.observantuserid ?? 0);
    newData.append('UpdatedUser', userSession?.user?.id ?? 0);

    newData.append('Accompaniment.called', calledId);
    newData.append('Accompaniment.finish', true);
    newData.append('Accompaniment.CalledStatus', targetStatusId);
    newData.append('Accompaniment.userAction', userSession?.user?.id ?? 0);
    newData.append('Accompaniment.calledTitle', calledGridData.title ?? '');
    newData.append('Accompaniment.privacy', privacy ? 'true' : 'false');
    newData.append('Accompaniment.description', actionDescription ?? '');
    newData.append('Accompaniment.originid', 2);
    newData.append('Accompaniment.CalledOrganizationCategory', calledGridData.organizationcategoryid ?? 0);
    newData.append('Accompaniment.CalledType', calledGridData.typeid ?? 0);
    newData.append('Accompaniment.CalledDescription', calledGridData.description ?? ' ');
    newData.append('Accompaniment.CalledAddressId', calledGridData.addressid ?? 0);
    newData.append('Accompaniment.CalledAssignedUser', calledGridData.assigneduserid ?? 0);
    newData.append('Accompaniment.CalledObservantUser', calledGridData.observantuserid ?? 0);
    newData.append('Accompaniment.RequestingUser', calledGridData.requestinguserid ?? 0);

    files.forEach((file) => {
      if (file instanceof File) {
        newData.append('Accompaniment.filesUpload', file);
      }
    });

    if (closingFormData && typeof closingFormData.entries === 'function') {
      for (const [key, value] of closingFormData.entries()) {
        newData.append(`CalledTipping.${key}`, value);
      }
    }

    if (closingFormData2 && typeof closingFormData2.entries === 'function') {
      for (const [key, value] of closingFormData2.entries()) {
        newData.append(`CalledClosing.${key}`, value);
      }
    }

    let timedOut = false;

    const apiPromise = Api.put('/calleds', newData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    timerRef.current = setTimeout(() => {
      timedOut = true;
      setSubmitting(false);
      onOptimisticClose?.();
      apiPromise
        .then((res) => {
          if (!res?.data?.success) {
            const errMsg = res?.data?.errors?.[0] ?? 'Erro ao finalizar chamado';
            onMoveError?.(calledId, errMsg);
          }
        })
        .catch((err) => {
          const errMsg = err?.response?.data?.errors?.[0] ?? 'Erro ao finalizar chamado';
          onMoveError?.(calledId, errMsg);
        });
    }, 5000);

    try {
      const res = await apiPromise;
      clearTimeout(timerRef.current);
      if (timedOut) return;

      if (res?.data?.success) {
        onFinishSuccess(calledId, {
          statusId: targetStatusId,
          statusName: targetStatus?.statusName ?? '',
          colorHex: targetStatus?.colorHex ?? '#6b7280',
        });
      } else {
        const errMsg = res?.data?.errors?.[0] ?? intl.formatMessage({ id: 'process.error' });
        setToast({ open: true, message: errMsg, severity: 'error' });
      }
    } catch (err) {
      clearTimeout(timerRef.current);
      if (timedOut) return;
      const errMsg = err?.response?.data?.errors?.[0] ?? intl.formatMessage({ id: 'process.error' });
      setToast({ open: true, message: errMsg, severity: 'error' });
    } finally {
      if (!timedOut) setSubmitting(false);
    }
  };

  const slaAttend = calledGridData ? getSlaAtendimento(calledGridData, userSession) : null;
  const slaSolution = calledGridData ? getSlaSolucao(calledGridData, userSession) : null;

  const skeletonContent = (
    <Box sx={{ p: 3, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      <Skeleton variant="text" height={32} width="50%" />
      <Skeleton variant="rectangular" height={56} />
      <Skeleton variant="rectangular" height={56} />
      <Skeleton variant="rectangular" height={56} />
      <Skeleton variant="text" height={24} width="35%" />
      <Skeleton variant="rectangular" height={120} />
    </Box>
  );

  return (
    <Dialog open={open} onClose={submitting || loading ? undefined : closeModalFinish} disableEscapeKeyDown={submitting || loading} fullWidth maxWidth="md">
      {loading || !calledGridData ? (
        skeletonContent
      ) : submitting ? (
        skeletonContent
      ) : (
        <TransitionsModal isopen={open} handleOpen={() => {}} handleClose={closeModalFinish}>
          <CalledFinish
            called={calledGridData}
            calledId={calledId}
            calledData={calledGridData}
            actionDescription={actionDescription}
            actionFinishId={finishAccompanimentId}
            files={files}
            addAccompanimentsList={addAccompanimentsList}
            user={userSession}
            slaAttend={slaAttend}
            slaSolution={slaSolution}
            handleClose={closeModalFinish}
            calledFinishOk={calledFinishOk}
            closeModalCalledFinish={closeModalCalledFinish}
            setFinishAccompanimentId={setFinishAccompanimentId}
            setActionDescription={setActionDescription}
            setDefaultActionAccompaniment={setDefaultActionAccompaniment}
            removeItem={removeItem}
            addFileItem={addFileItem}
            defaultActionList={defaultActionList}
            caninformutilizedmaterialsincalledfinish={false}
            canfinalchecklistisrequired={false}
            actionRadio={actionRadio}
            setClosingCalledModalDataForm={setClosingFormData}
            setClosingCalledModalDataForm2={setClosingFormData2}
            asynchronousClosingCalled={false}
          />
        </TransitionsModal>
      )}
    </Dialog>
  );
}

const mapStateToProps = (state) => ({
  userSession: state.userSession,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...calledsActions }, dispatch);

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(KanbanFinishModal));
